import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const fetchUserProfileTE = <E = CF.API.ApiError>(
  { userId, params = '', sessionToken }: { userId?: string; params?: string; sessionToken?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.GetUserMeResponse> =>
  fetchTE<CF.API.Users.GetUserMeResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}${params ? `?${params}` : ''}`,
      sessionToken,
      method: 'GET',
    },
    onRejected,
  );
